export const ListQueryKey = 'bills';
export const DetailQueryKey = 'bill';

export const Urls = {
  selectUrl: '/bill/list',
};
